var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from "@core/libs";
import NavBarItem from "frontend/ts/components/NavBarItem";
var NavBarToggle = /** @class */ (function (_super) {
    __extends(NavBarToggle, _super);
    function NavBarToggle(element) {
        var _this = _super.call(this, element) || this;
        _this.selector = '.has-expand-toggle';
        _this.element = element;
        return _this;
    }
    NavBarToggle.prototype.onMounted = function () {
        var listEl = this.element.querySelectorAll(this.selector);
        listEl.forEach(function (el) {
            new NavBarItem(el);
        });
    };
    return NavBarToggle;
}(Lib));
export default NavBarToggle;
